/**
 * @author Sunil Jain
 * @description Single source of truth for all content block type constants.
 * These string values MUST match the enums in the backend (e.g., models.py -> ProcessedContentBlockType).
 */
export const BLOCK_TYPES = {
    YES_NO: "yes_no",
    SINGLE_CHOICE_SELECT: "single_choice_select",
    MULTI_CHOICE_SELECT: "multi_choice_select",
    SCALE: "numeric_scale",
    OPEN_TEXT: "open_text",
    NUMBER: "number",
    INFO_TEXT: "info_text",
    PAIN_MAP: "pain_map",
    STANDARDIZED_ASSESSMENT: "standardized_assessment",
    QUIZ_QUESTION_CHOICE: "quiz_question_choice",
    QUIZ_QUESTION_OPEN_TEXT: "quiz_question_open_text",
};